export const errors = {
    PRODUCT_DESCRIPTION_GENERATION: {
        title: 'Erreur lors de la génération de la description',
        message: 'Veuillez réessayer avec une image moins lourde ou contactez notre support.',
    },
    PRODUCT_CREATION: {
        title: 'Erreur lors de la création du produit',
        message: 'Erreur lors de la création du produit. Veuillez réessayer.',
    },
    PRODUCT_UPDATE: {
        title: 'Erreur lors de la mise à jour du produit',
        message: 'Erreur lors de la mise à jour du produit. Veuillez réessayer.',
    },
    ORDER_CREATION: {
        title: 'Erreur lors de la création de la commande',
        message: 'Erreur lors de la création de la commande',
    },
    ORDER_CANCELLATION: {
        title: 'Erreur lors de l\'annulation de la commande',
        message: 'Erreur lors de l\'annulation de la commande',
    },
    ORDER_PAYMENT: {
        title: 'Erreur lors du paiement de la commande',
        message: 'Erreur lors du paiement de la commande',
    },
    ORDER_SHIPPING: {
        title: 'Erreur lors de l\'envoi de la commande',
        message: 'Erreur lors de l\'envoi de la commande',
    },
    ORDER_DELIVERY: {
        title: 'Erreur lors de la livraison de la commande',
        message: 'Erreur lors de la livraison de la commande',
    },
    ORDER_RETURN: {
        title: 'Erreur lors de la demande de retour de la commande',
        message: 'Erreur lors de la demande de retour de la commande',
    },
}